import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiMenu {
    constructor() {

    }

    checkMenu() {
    }

    createMenu() {
    }

    disableMenu() {
    }

    enableMenu() {
    }

    menuChecked() {
    }

    menuEnabled() {
    }

    menuText() {
    }

    setMenuText() {
    }

    uncheckMenu() {
    }

    updateWindowMenu() {
    }

    windowMenu() {
    }
}
